import { mainnetContractConfig, testnetContractConfig } from "./contractConfig";

export const EXPECTED_CHAIN_ID = Number(process.env.REACT_APP_EXPECTED_CHAIN_ID)
export const EXPECTED_ARB_CHAIN_ID = Number(process.env.REACT_APP_EXPECTED_ARB_CHAIN_ID)
export const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL
export const ART_BLOCKS_METADATA_GRAPHQL_URL =
  process.env.REACT_APP_ART_BLOCKS_METADATA_GRAPHQL_URL || "https://data.artblocks.io/v1/graphql"
export const WALLET_CONNECT_PROJECT_ID = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID || ""
export const INFURA_KEY = process.env.REACT_APP_INFURA_KEY || ""
export const ETHEREUM_RPC_URL =
  process.env.REACT_APP_ETHEREUM_RPC_URL ||
  (INFURA_KEY ? `https://mainnet.infura.io/v3/${INFURA_KEY}` : "https://ethereum.publicnode.com")
export const INFURA_ARB_URL = process.env.REACT_APP_INFURA_ARB_URL || ""
export const ARBITRUM_RPC_URL =
  process.env.REACT_APP_ARBITRUM_RPC_URL || INFURA_ARB_URL || "https://arb1.arbitrum.io/rpc"
export const BASE_RPC_URL = process.env.REACT_APP_BASE_RPC_URL || "https://mainnet.base.org"
const DEFAULT_CHAIN_CACHE_TTL_MS = 60 * 60 * 1000
const chainCacheTtlEnv = process.env.REACT_APP_CHAIN_CACHE_TTL_MS
const configuredChainCacheTtlMs = chainCacheTtlEnv ? Number(chainCacheTtlEnv) : Number.NaN
export const CHAIN_CACHE_TTL_MS =
  Number.isFinite(configuredChainCacheTtlMs) && configuredChainCacheTtlMs >= 0
    ? configuredChainCacheTtlMs
    : DEFAULT_CHAIN_CACHE_TTL_MS
export const ARTIST_ADDRESSES = [
  '0xf2162bacc9f76608ba4b11b1a6dac976ed463129', // r4v3n-deployer.eth
  '0x65de6475258e3736e5c7d502d2c0a45710c9ec37', // r4v3n.eth
]
export const ARTIST_ADDRESS = ARTIST_ADDRESSES[0]
export type FeaturedProjectKey = "dots" | "dots-composites"
export interface FeaturedProject {
  key: FeaturedProjectKey
  name: string
  artistName: string
  chainId: 42161
  chainName: string
  contractAddress: string
  projectId: string
  detailPath: string
  projectUrl: string
  artBlocksUrl: string
  sampleTokenId: string
  aspectRatio: number
  sampleDotIds: string[]
  statusLabel: string
  supplyLabel: string
  description: string
  detailDescription: string[]
}

export const FEATURED_PROJECTS: FeaturedProject[] = [
  {
    key: "dots",
    name: "Dots",
    artistName: "r4v3n",
    chainId: 42161,
    chainName: "Arbitrum",
    contractAddress: "0x47a91457a3a1f700097199fd63c039c4784384ab",
    projectId: "301",
    detailPath: "/dots",
    projectUrl: "https://dots.r4v3n.art/project/0x47a91457a3a1f700097199fd63c039c4784384ab/301",
    artBlocksUrl: "https://www.artblocks.io/collection/dots-by-r4v3n",
    sampleTokenId: "301000000",
    aspectRatio: 1,
    sampleDotIds: ["0", "1", "2", "3"],
    statusLabel: "Sold Out",
    supplyLabel: "Inclusive edition",
    description:
      "An Art Blocks Engine project on Arbitrum built from code-based paint strokes, where individual dots become atomic units for future collaborative compositions.",
    detailDescription: [
      'Dots is the beginning of a generative art ecosystem envisioned by r4v3n. It distills the painterly language of "Moments" and "Pieces of Me" into simple on-chain marks that can stand alone or become ingredients for future works.',
      "Each dot is generated from code-based paint strokes rotated around a center point. The result is a compact, collectible unit that carries r4v3n's hand, palette, and compositional rhythm into a new Art Blocks Engine format.",
      "The project is designed to be accessible and extensible: a finished artwork on its own, and a building block for later collaborative systems."
    ],
  },
  {
    key: "dots-composites",
    name: "Dots: Composites",
    artistName: "r4v3n",
    chainId: 42161,
    chainName: "Arbitrum",
    contractAddress: "0x0d39ab55664007ff2d089a25480f169c6d0597bb",
    projectId: "0",
    detailPath: "/dots-composites",
    projectUrl: "https://dots.r4v3n.art/project/0x0d39ab55664007ff2d089a25480f169c6d0597bb/0",
    artBlocksUrl: "https://www.artblocks.io/collection/dots-composites-by-r4v3n",
    sampleTokenId: "2",
    aspectRatio: 0.75,
    sampleDotIds: ["4", "0", "2", "1"],
    statusLabel: "Sold Out",
    supplyLabel: "Composite builder",
    description:
      "A companion Art Blocks Engine project where collectors combine Dots into larger compositions, expanding each dot into a shared creative system.",
    detailDescription: [
      "Dots: Composites extends the Dots ecosystem into a collaborative builder. Collectors can combine selected dots into larger compositions that inherit the character of the dots used at mint time.",
      "The project turns individual marks into a flexible visual vocabulary: small, complete works can become source material for broader arrangements without losing their original identity.",
      "Together, Dots and Dots: Composites make the Work page read as the full ecosystem rather than a single project."
    ],
  },
]
export const getFeaturedProject = (key: FeaturedProjectKey) =>
  FEATURED_PROJECTS.find((project) => project.key === key)
export const DOTS_PROJECT_CONTRACT_ADDRESS = FEATURED_PROJECTS[0].contractAddress
export const DOTS_PROJECT_ID = FEATURED_PROJECTS[0].projectId
export const DOTS_PROJECT_URL = FEATURED_PROJECTS[0].projectUrl
export const DOTS_COMPOSITES_PROJECT_CONTRACT_ADDRESS = FEATURED_PROJECTS[1].contractAddress
export const DOTS_COMPOSITES_PROJECT_ID = FEATURED_PROJECTS[1].projectId
export const DOTS_COMPOSITES_PROJECT_URL = FEATURED_PROJECTS[1].projectUrl
export const PROJECTS_PER_PAGE = 8
export const TOKENS_PER_PAGE = 9
export const MULTIPLY_GAS_LIMIT = 1.1
export const CONTRACT_INFO = EXPECTED_CHAIN_ID === 1 ? mainnetContractConfig : testnetContractConfig
export const MERKLE_PROOF_API_URL = process.env.REACT_APP_MERKLE_PROOF_API_URL || ""
export const HOLDER_PROOF_API_URL = process.env.REACT_APP_HOLDER_PROOF_API_URL || ""
